const routes = {
  '/app/dashboard': {
    fetch: () =>
      import(
        /* webpackChunkName: 'member-home-route' */ 'app/member-home/asyncRoute'
      ).then(module => module.default),
  },
  '/app': {
    onEnter({ router, routeTo }) {
      routeTo(`/app/dashboard${router.next.location.search || ''}`);
    },
  },
  '/app/home': {
    onEnter({ router, routeTo }) {
      routeTo(`/app/dashboard${router.next.location.search || ''}`);
    },
  },
};

export default routes;
